import { type SearchableSelectItem } from "@/components/molecules/searchable-select";
import { useServices } from "@/features/services/hooks/use-services";
import { BriefcaseIcon } from "@phosphor-icons/react";
import { useMemo } from "react";

/**
 * The tenant's services as `SearchableSelect` items. Shared by the single- and
 * multi-select below, which differ only in arity.
 */
export function useServiceItems() {
  const { data: services = [], isLoading } = useServices();

  const items: SearchableSelectItem[] = useMemo(
    () =>
      services.map((service) => ({
        id: service.id,
        label: service.name,
        description: service.description,
        icon: <BriefcaseIcon className="h-4 w-4" />,
        data: service,
      })),
    [services],
  );

  return { items, isLoading };
}

/** The icon the "no service" entry carries, so it matches the real ones. */
export const serviceIcon = <BriefcaseIcon className="h-4 w-4" />;
